module.exports = __webpack_public_path__ + "static/media/SpaceLogoWhite_S.92c3ebcd.png";